import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userId: '',
  userEmail: '',
  isBindPay: false,
  isStart: false,
};

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setIsStart: (state, action) => {
      state.isStart = action.payload;
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    setUserEmail: (state, action) => {
      state.userEmail = action.payload;
    },
    setIsBindPay: (state, action) => {
      state.isBindPay = action.payload;
    },
  },
});

export const { setUserId, setUserEmail, setIsBindPay, setIsStart } = loginSlice.actions;

// Селекторы для userId и userEmail
export const selectUserId = (state) => state.login.userId;
export const selectUserEmail = (state) => state.login.userEmail;
export const selectIsBindPay = (state) => state.login.isBindPay;
export const selectIsStart = (state) => state.login.isStart;

export default loginSlice.reducer;
